<template>
  <div>
    <DarkModeSwitcher />
    <div class="container sm:px-10">
      <div class="block xl:grid grid-cols-2 gap-4">
        <!-- BEGIN: Register Info -->
        <div class="hidden xl:flex flex-col min-h-screen">
          <a href="" class="-intro-x flex items-center pt-5">
            <img
              alt="Midone Tailwind HTML Admin Template"
              class="w-6"
              :src="require(`@/assets/images/logo.svg`)"
            />
            <span class="text-white text-lg ml-3">
              <span class="text-2xl">MSN</span>
            </span>
          </a>
          <div class="my-auto">
            <img
              alt="Midone Tailwind HTML Admin Template"
              class="-intro-x w-1/2 -mt-16"
              :src="require(`@/assets/images/illustration.svg`)"
            />
            <div
              class="-intro-x text-white font-medium text-4xl leading-tight mt-10"
            ></div>
            <div
              class="-intro-x mt-5 text-lg text-white dark:text-gray-500"
            ></div>
          </div>
        </div>
        <!-- END: Register Info -->
        <!-- BEGIN: Register Form -->
        <div class="h-screen xl:h-auto flex py-5 xl:py-0 my-10 xl:my-0">
          <div
            class="my-auto mx-auto xl:ml-20 bg-white xl:bg-transparent px-5 sm:px-8 py-8 xl:p-0 rounded-md shadow-md xl:shadow-none w-full sm:w-3/4 lg:w-2/4 xl:w-auto"
          >
            <h2
              class="intro-x font-bold text-2xl xl:text-3xl text-center xl:text-left"
            >
              등록
            </h2>
            <div class="intro-x mt-8">
              <input
                v-model="register.username"
                type="text"
                autocomplete="off"
                class="intro-x login__input input input--lg border border-gray-300 block"
                placeholder="이름"
              />
              <input
                v-model="register.email"
                type="text"
                autocomplete="off"
                class="intro-x login__input input input--lg border border-gray-300 block mt-4"
                placeholder="이메일"
              />
              <div
                class="intro-x login__input rounded-md border border-gray-300 relative block mt-4"
              >
                <SearchIcon
                  class="w-4 h-4 absolute my-auto inset-y-0 ml-3 left-0 z-10 text-gray-700 dark:text-gray-300"
                />
                <input
                  id="agency_id"
                  v-model="register.agencyName"
                  type="text"
                  autocomplete="off"
                  class="input w-full px-10 py-3 text-gray-700 dark:text-gray-300"
                  placeholder="지점이름"
                  @focus="showSearchDropdown"
                  @blur="hideSearchDropdown"
                  @input="onChangeInput($event)"
                  @keyup.enter="enterSelect()"
                />
                <div
                  class="inbox-filter dropdown absolute inset-y-0 mr-3 right-0 flex items-center"
                >
                  <ChevronDownIcon
                    class="dropdown-toggle w-4 h-4 cursor-pointer text-gray-700 dark:text-gray-300"
                    @focus="showSearchDropdown"
                    @blur="hideSearchDropdown"
                  />
                </div>
                <div
                  class="dropdown-box w-full"
                  :class="{ show: searchDropdown }"
                >
                  <div
                    class="dropdown-box__content box dark:bg-dark-1 p-2 overflow-y-auto h-32"
                  >
                    <a
                      v-for="(agency, index) in agencies"
                      :key="index"
                      class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
                      @click="onSelect(agency)"
                      >{{ agency.name }}</a
                    >
                  </div>
                </div>
              </div>
              <input
                v-model="register.password"
                type="password"
                autocomplete="off"
                class="intro-x login__input input input--lg border border-gray-300 block mt-4"
                placeholder="비번"
              />
              <input
                v-model="register.passwordConfirm"
                type="password"
                autocomplete="off"
                class="intro-x login__input input input--lg border border-gray-300 block mt-4"
                placeholder="비번 확인"
              />
            </div>
            <div class="intro-x mt-5 xl:mt-8 text-center xl:text-left">
              <button
                class="button button--lg w-full xl:w-32 text-white bg-theme-1 xl:mr-3 align-top"
                @click="clickRegisterBtn()"
              >
                등록
              </button>
              <button
                class="button button--lg w-full xl:w-32 text-gray-700 border border-gray-300 dark:border-dark-5 dark:text-gray-300 mt-3 xl:mt-0 align-top"
                @click="signIn()"
              >
                로그인
              </button>
            </div>
          </div>
        </div>
        <!-- END: Register Form -->
      </div>
    </div>
  </div>
</template>

<script>
import DarkModeSwitcher from "@/components/DarkModeSwitcher";
import axios from "axios";
import Toastify from "toastify-js";

export default {
  components: {
    DarkModeSwitcher
  },
  data() {
    return {
      agencies: [],
      tmpAgencies: [],
      register: {
        username: "",
        email: "",
        password: "",
        passwordConfirm: "",
        agencyId: 0,
        agencyName: ""
      },
      searchDropdown: false
    };
  },
  async mounted() {
    cash("body")
      .removeClass("app")
      .addClass("login");
    await this.getAgencies();
  },
  methods: {
    signIn() {
      this.$router.replace("/");
    },
    async getAgencies() {
      await axios
        .post(this.$api().getAgencies)
        .then(res => {
          let resultData = this.$h.assign(res.data);
          this.agencies = resultData.data;
          this.tmpAgencies = [...this.agencies];
        })
        .catch(err => {
          console.dir(err);
        });
    },
    showSearchDropdown() {
      this.searchDropdown = true;
    },
    hideSearchDropdown() {
      this.searchDropdown = false;
    },
    onSelect(agency) {
      this.register.agencyName = agency.name;
      this.register.agencyId = agency.id;
    },
    enterSelect() {
      const agencyName = this.register.agencyName;
      this.agencies = this.$h.findItemsFromArray(this.tmpAgencies, agencyName);
      if (this.agencies.length > 0) {
        this.register.agencyName = this.agencies[0].name;
        this.register.agencyId = this.agencies[0].id;
      } else {
        this.register.agencyName = "";
        this.register.agencyId = "";
      }
    },
    onChangeInput() {
      const agencyName = this.register.agencyName;
      this.agencies = this.$h.findItemsFromArray(this.tmpAgencies, agencyName);
      if (this.agencies.length > 0) {
        this.register.agencyId = this.agencies[0].id;
      } else {
        this.register.agencyId = "";
      }
    },
    async clickRegisterBtn() {
      let message = "";
      if (this.register.agencyId == 0) {
        message = "지점을 선택해주세요.";
      }
      if (this.register.password == "") {
        message = "Password is Null.";
      }
      if (this.register.email == "") {
        message = "Email is Null.";
      }
      if (this.register.password != this.register.passwordConfirm) {
        message = "Password Error";
      }
      if (message != "") {
        Toastify({
          text: message,
          duration: 3000,
          newWindow: true,
          close: true,
          gravity: "bottom",
          position: "left",
          backgroundColor: "#e53231",
          stopOnFocus: true
        }).showToast();
        return;
      }
      await axios
        .post(this.$api().register, this.register)
        .then(res => {
          // console.log(res);
          if (res.status == 201) {
            Toastify({
              text: res.data.error,
              duration: 3000,
              newWindow: true,
              close: true,
              gravity: "bottom",
              position: "left",
              backgroundColor: "#e53231",
              stopOnFocus: true
            }).showToast();
          } else {
            Toastify({
              text: "등록성공되었습니다.",
              duration: 3000,
              newWindow: true,
              close: true,
              gravity: "bottom",
              position: "left",
              backgroundColor: "#0e2c88",
              stopOnFocus: true
            }).showToast();
            this.$router.replace("/");
          }
        })
        .catch(err => {
          console.dir(err);
        });
    }
  }
};
</script>
